import _asyncToGenerator from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './HeaderForActivationPage.css';
import React, { useRef } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Recaptcha from '../Login/components/Recaptcha';
import { loaderToggle } from '../../utils/setUserCookie';
var HeaderForActivationPage = function HeaderForActivationPage(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  var clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isRegistrationSuccess = _React$useState2[0],
    setIsRegistrationSuccess = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userId = _React$useState4[0],
    setUserId = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    formResponseError = _React$useState6[0],
    setFormResponseError = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    recaptchaError = _React$useState8[0],
    setRecaptchaError = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    disableSubmit = _React$useState10[0],
    setDisableSubmit = _React$useState10[1];
  var titleSuccess = get(fields, 'data.item.titleSuccess.jss.value') || '';
  var introTextSuccess = get(fields, 'data.item.introTextSuccess.jss.value') || '';
  var titleFailed = get(fields, 'data.item.titleFailed.jss.value') || '';
  var introTextFailed = get(fields, 'data.item.introTextFailed.jss.value') || '';
  var loginPageLink = get(fields, 'data.item.loginPageLink.jss.value.href') || '';
  var thankYouPageLink = get(fields, 'data.item.thankYouPageLink.jss.value.href') || '';
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var SubmitBtnText = mapDictionary.get('SubmitButtonText');
  var RedirectBtnText = mapDictionary.get('SuccessBtnText') || '';
  var recaptchErrorMessage = mapDictionary.get('FieldErrorRequiredRecaptcha');
  var formPostErrors = [];
  var generalErrorCode = 'Failed';
  var allErrors = [];
  var recaptchaRef = useRef(null);
  var _React$useState11 = React.useState(true),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isVdsite = _React$useState12[0],
    setIsVdsite = _React$useState12[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var describeTextRef = React.useRef(null);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex', '#000');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var styleThemeHexColor = BackgroundColorHex ? {
    '--header-for-activation-page-background-color': BackgroundColorHex,
    '--header-for-activation-page-active-color': ActiveColorHex,
    '--header-for-activation-page-color': ColorHex
  } : {
    '--header-for-activation-page-background-color': selectedPrimaryColor,
    '--header-for-activation-page-active-color': selectedPrimaryActiveColor,
    '--header-for-activation-page-color': getColorByTheme(selectedPrimaryColor)
  };
  formPostErrors.push({
    errorCode: generalErrorCode,
    message: mapDictionary.get('MessageConfirmationApiFail')
  });
  React.useEffect(function () {
    if (canUseDOM) {
      var url = new URL(window.location.href);
      var result = url.searchParams.get('result');
      var errors = url.searchParams.get('errors');
      if (errors && result) {
        if (errors.includes('verified_already')) {
          setIsRegistrationSuccess(true);
        } else if (result.toLocaleLowerCase() !== 'true') {
          setIsRegistrationSuccess(false);
          setUserId(errors.replace('InvalidToken,', ''));
        }
      }
    }
  }, []);
  React.useEffect(function () {
    if (describeTextRef && describeTextRef.current) {
      describeTextRef.current.innerHTML = isRegistrationSuccess ? introTextSuccess : introTextFailed;
    }
  }, [isRegistrationSuccess]);
  if (!fields) {
    console.warn('HeaderForActivationPage component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[HeaderForActivationPage component is empty: please provide datasource]");
    }
    return null;
  }
  var resendLink = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var myHeaders, statusCode, recaptchaToken, formdata, requestOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');
            statusCode = 0;
            if (!recaptchaRef.current) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return recaptchaRef.current.getRecaptchaToken();
          case 6:
            recaptchaToken = _context.sent;
          case 7:
            if (!recaptchaToken) {
              setRecaptchaError(recaptchErrorMessage);
            } else {
              setRecaptchaError('');
            }
            formdata = new FormData();
            formdata.append('g-recaptcha-response', recaptchaToken);
            formdata.append('clientId', clientId);
            formdata.append('userId', userId);
            requestOptions = {
              method: 'POST',
              headers: myHeaders,
              redirect: 'follow',
              body: formdata
            };
            _context.next = 15;
            return fetch("".concat(identityGlobal, "/api/account/ResendUserConfirmation"), requestOptions).then(function (response) {
              loaderToggle(false, setDisableSubmit);
              statusCode = response.status;
              return response.text();
            }).then(function (result) {
              var responseObj;
              if (result) {
                responseObj = JSON.parse(result);
              }
              if (statusCode === 200) {
                if (responseObj.isSuccess) {
                  if (canUseDOM) {
                    if (thankYouPageLink) {
                      window.location.href = thankYouPageLink;
                    } else {
                      console.log('please fill in thankYouPageLink');
                    }
                  }
                } else if (!responseObj.isSuccess) {
                  if (responseObj.errors && responseObj.errors.length) {
                    throw Error(responseObj.errors[0].code);
                  }
                }
              } else {
                throw Error(generalErrorCode);
              }
            }).catch(function (error) {
              loaderToggle(false, setDisableSubmit);
              if (statusCode === 0) {
                showResponseError(generalErrorCode);
              } else {
                showResponseError(error.message);
              }
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function resendLink() {
      return _ref2.apply(this, arguments);
    };
  }();

  // Validate all fields on submit
  var validateAllFields = function validateAllFields() {
    var success = true;
    for (var _i = 0, _allErrors = allErrors; _i < _allErrors.length; _i++) {
      var fieldObj = _allErrors[_i];
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };

  // Form submit handler
  var formSubmit = function formSubmit(event) {
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      resendLink();
    }
    event.preventDefault();
  };
  var showResponseError = function showResponseError(errorCode) {
    var errorObject = formPostErrors.find(function (errorItem) {
      return errorItem.errorCode === errorCode;
    });
    if (errorObject) {
      setFormResponseError(errorObject.message);
    } else {
      setFormResponseError(formPostErrors[0].message);
    }
  };
  var redirectToLogin = function redirectToLogin() {
    if (canUseDOM) {
      window.location.href = loginPageLink;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h2 c-title__text"
  }, isRegistrationSuccess ? titleSuccess : titleFailed), /*#__PURE__*/React.createElement("p", {
    className: "p header__content",
    ref: describeTextRef
  }), isRegistrationSuccess && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__submit-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "button",
    disabled: loginPageLink ? false : true,
    onClick: redirectToLogin
  }, RedirectBtnText)))), !isRegistrationSuccess && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__submit-row"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "button",
    disabled: disableSubmit,
    onClick: formSubmit
  }, SubmitBtnText)))), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c18bm3su";
var rtlStyles = "r1arkr39";
var ltrStyles = "l1vdir0n";
export default HeaderForActivationPage;